<template>
  <div>
    <div class="spacer-55"></div>
    <div class="spacer-55"></div>
    <div v-if="visible">
      <h2>Работа с приложением в данный момент невозможна!</h2>
      <div v-if="globalError" v-html="globalError"></div>
      <lk-button @click="reloadClient" value="Обновить" />
      <lk-button @click="logout" value="Выйти" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      visible: false,
    };
  },
  created() {
    // TODO: сдедать как-то по человечески, добавить окно загрузки
    const action = () => {
      this.visible = true;
    };
    setTimeout(action, 5 * 1000);
  },
  computed: {
    ...mapGetters(["globalError"]),
  },
  methods: {
    ...mapActions(["fetchClient"]),

    reloadClient() {
      this.fetchClient();
    },
    logout() {
      this.$router.replace("/logout");
    },
  },
};
</script>
